import { render, staticRenderFns } from "./DatasourceEdit.vue?vue&type=template&id=f0fc0fda&"
import script from "./DatasourceEdit.vue?vue&type=script&lang=js&"
export * from "./DatasourceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f0fc0fda')) {
      api.createRecord('f0fc0fda', component.options)
    } else {
      api.reload('f0fc0fda', component.options)
    }
    module.hot.accept("./DatasourceEdit.vue?vue&type=template&id=f0fc0fda&", function () {
      api.rerender('f0fc0fda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/DatasourceEdit.vue"
export default component.exports